/**
 * Test script to verify the regex fix for image URL matching
 * This script tests the image URL parsing logic used in the sync functionality
 */

(function() {
    'use strict';
    
    console.log('🧪 Testing image URL regex patterns...');
    
    // Test cases from the user's logs
    const testCases = [
        {
            name: 'Sparklayer image (348x)',
            url: 'https://cdn.shopify.com/s/files/1/0726/3875/9138/files/SET1896-2_348x.jpg?v=1759984285',
            expected: 'SET1896-2'
        },
        {
            name: 'Carousel image (840x)',
            url: 'https://kalliopejewelry.com/cdn/shop/files/SET1896-2_840x.jpg?v=1759984285',
            expected: 'SET1896-2'
        },
        {
            name: 'Carousel image (1680x)',
            url: 'https://kalliopejewelry.com/cdn/shop/files/SET1896-2_1680x.jpg?v=1759984285',
            expected: 'SET1896-2'
        },
        {
            name: 'Complex filename',
            url: 'https://cdn.shopify.com/s/files/1/0726/3875/9138/files/SET1896-101-09-0_348x.jpg?v=1759984285',
            expected: 'SET1896-101-09-0'
        }
    ];
    
    function extractBaseFilename(url) {
        const filename = url.split('/').pop().split('?')[0];
        const base = filename.replace(/_\d+x/, '').replace(/\.(jpg|jpeg|png|webp)$/i, '');
        return base;
    }
    
    function testRegexPatterns() {
        console.log('\n📋 Testing regex patterns:');
        
        testCases.forEach((testCase, index) => {
            const result = extractBaseFilename(testCase.url);
            const passed = result === testCase.expected;
            
            console.log(`\nTest ${index + 1}: ${testCase.name}`);
            console.log(`  URL: ${testCase.url}`);
            console.log(`  Expected: ${testCase.expected}`);
            console.log(`  Result: ${result}`);
            console.log(`  Status: ${passed ? '✅ PASS' : '❌ FAIL'}`);
            
            if (!passed) {
                console.log(`  ❌ Mismatch! Expected "${testCase.expected}" but got "${result}"`);
            }
        });
    }
    
    function testOldVsNewRegex() {
        console.log('\n🔄 Comparing old vs new regex:');
        
        const testUrl = 'https://cdn.shopify.com/s/files/1/0726/3875/9138/files/SET1896-2_348x.jpg?v=1759984285';
        const filename = testUrl.split('/').pop().split('?')[0];
        
        // Old regex (didn't work for _348x)
        const oldResult = filename.replace(/_\d+x\d+/, '').replace(/\.(jpg|jpeg|png|webp)$/i, '');
        
        // New regex (works for both _348x and _840x)
        const newResult = filename.replace(/_\d+x/, '').replace(/\.(jpg|jpeg|png|webp)$/i, '');
        
        console.log(`  Filename: ${filename}`);
        console.log(`  Old regex result: ${oldResult}`);
        console.log(`  New regex result: ${newResult}`);
        console.log(`  Old regex works: ${oldResult === 'SET1896-2' ? '✅' : '❌'}`);
        console.log(`  New regex works: ${newResult === 'SET1896-2' ? '✅' : '❌'}`);
    }
    
    // Run tests
    testRegexPatterns();
    testOldVsNewRegex();
    
    console.log('\n🎯 Summary:');
    console.log('The new regex `/_\d+x/` should now correctly handle both:');
    console.log('- Sparklayer images: _348x format');
    console.log('- Carousel images: _840x, _1680x formats');
    console.log('- All should extract to the same base filename for matching');
    
    // Make test function globally available
    window.testImageRegex = testRegexPatterns;
    
})();
